/* eslint-disable react-hooks/exhaustive-deps */
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";
import Auth from "../pages/auth";
import { useApp } from "../contexts";
import WalletList from "../pages/wallet-list";
import Header from "../components/Layout/header.main";
import WalletDetail from "../pages/wallet-detail-history";
import WalletDetailHistory from "../pages/wallet-detail-history-old";
import Withdraw from "../pages/withdraw";
import TransferWeb3 from "../pages/transfer-web3";
import TransactionHistory from "../pages/transaction-history";
import Commission from "../pages/commission";
import CommissionDetail from "../pages/commission-detail";
import { StakeDetail } from "../pages/stake-detail";
import StakeSuccess from "../pages/stake-success";
import Footer from "../components/Layout/footer";
import ConfirmPhone from "../pages/confirm-phone";
import {
  agreePolicy,
  getInfoByCodeSSO,
  postUserLastAccess,
} from "../services/app";
import { CountryCode, DOMAIN_COOKIE, KEY_COOKIE } from "../constants";
import { Logout } from "../pages/logout";
import { setCookie } from "../utils/helper";
import { LoadingSplash2 } from "../components/Loading2";
import { Home } from "../pages/Home";
import { ChangePassword } from "../pages/change-password";
import { OtpVerification } from "../pages/otp-verification";
import { TwoFactor } from "../pages/two-factor";
import { Profile } from "../pages/profile";
import { MyPurchase } from "../pages/my-purchase";
import { Asset } from "../pages/asset";
import { EarnerDetail } from "../pages/earner-detail";
import { CardInfo } from "../pages/card-info";
import { Affiliate } from "../pages/Affiliate";
import { AffiliateGenerate } from "../pages/affiliate-generate";
import { SetPassword } from "../pages/set-password";
import AddressBook from "../pages/address-book";
import MintNFT from "../pages/mint-nft";
import ClaimSot from "../pages/claim-sot";
import WithDrawSGT from "../pages/withdraw-sgt/components/WithDrawSGT";
import { PaymentMethod } from "../pages/payment-method";
import StakeSgt from "../pages/stake-sgt";
import ReStakeSgt from "../pages/re-stake-sgt";
import { StakeForOption } from "../pages/stake-for-option/StakeForOption";
import { StakeForOptionDetail } from "../pages/stake-for-option-detail";
import { StakeHistory } from "../pages/wallet-list/components/StakeHistory";
import StakeForVoting from "../pages/stake-for-voting";
import Stake from "../pages/stake";
import LineCallback from "../pages/line-callback";
import { ModalPolicy } from "../components/AffiliateComponent/ModalPolicy";
import { ClaimStakingRequest } from "../pages/claim-staking-request";
import { ClaimStakeSuccess } from "../pages/claim-stake-success";

export default function AppRouter() {
  const { user, setUser, reloadProfile, T } = useApp();
  const location = useLocation();
  const [isReadyRender, setIsReadyRender] = useState(false);
  // const lastAccessTokenRef = useRef(null);

  let params = new URLSearchParams(window.location.search);
  let code = params.get("code");

  useEffect(() => {
    if (code?.length > 20) {
      getInfoByCodeSSO(code).then((res) => {
        setUser({
          token: res?.data?.data?.data?.access_token,
          refreshToken: res?.data?.data?.data?.refresh_token,
          token_sso: res?.data?.data?.data?.access_token,
          reload: Date.now(),
        });
        const ONE_YEAR_IN_MS = 365 * 24 * 60 * 60 * 1000;
        const cookieData = JSON.stringify({
          access_token: res?.data?.data?.data?.access_token || "",
          refresh_token: res?.data?.data?.data?.refresh_token || "",
          expires_in:
            res.data?.data?.data?.expires_in ||
            Date.now() + 10 * ONE_YEAR_IN_MS,
          token_type: "Bearer",
          user: {},
        });
        setCookie(KEY_COOKIE.AUTH_TOKEN_COOOKIE, cookieData, {
          domain: DOMAIN_COOKIE,
          maxAge: Date.now() + 36135 * 86400000,
        });
        if (typeof window?.history?.pushState === "function") {
          let urlCurrent = window.location.href;
          urlCurrent = urlCurrent.replace(`?code=${code}`, "");
          urlCurrent = urlCurrent.replace(`&code=${code}`, "");
          window.history.pushState({ path: urlCurrent }, "", urlCurrent);
        }
        setIsReadyRender(true);
      });
    } else {
      setIsReadyRender(true);
    }
  }, [code, setUser]);

  const handlePostLastAccess = useCallback(() => {
    if (user?.token) {
      try {
        postUserLastAccess("ams");
      } catch (error) {}
    }
  }, [user?.token]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    if (!user?.token) return;
    reloadProfile();
  }, [location.pathname]);

  useEffect(() => {
    handlePostLastAccess();
  }, [handlePostLastAccess]);

  const [isOpenModalPolicy, setIsOpenModalPolicy] = useState(false);
  const isConfirmedPolicy = useMemo(
    () => Number(user?.is_agree_policy) === 1 && !!user?.agree_policy_date,
    [user],
  );
  const isAffiliateSource = useMemo(() => {
    const nonAffSources = ["internal_test", "app"];
    return !nonAffSources.includes(user?.source);
  }, [user]);
  const isVerifyPhoneStatus = useMemo(
    () => Boolean(user?.verify_phone_status ?? 0),
    [user],
  );
  const isUpdatedInformation = useMemo(
    () => Boolean(user?.dob && user?.gender && user?.name),
    [user],
  );
  useEffect(() => {
    if (
      !isConfirmedPolicy &&
      isAffiliateSource &&
      isVerifyPhoneStatus &&
      isUpdatedInformation
    ) {
      setIsOpenModalPolicy(true);
    }
  }, [
    location.pathname,
    isConfirmedPolicy,
    isVerifyPhoneStatus,
    isUpdatedInformation,
  ]);
  const [isAgreeing, setIsAgreeing] = useState(false);
  const onConfirmPolicy = async () => {
    try {
      setIsAgreeing(true);
      await agreePolicy({
        isIgnoreValidation: true,
      });
      setIsOpenModalPolicy(false);
      reloadProfile();
    } catch (error) {
      console.error("Failed to agree policy:", error);
      Notification.error(
        error?.response?.data?.message ??
          T("Something went wrong! Please try again later!"),
      );
    } finally {
      setIsAgreeing(false);
    }
  };

  if (!isReadyRender) {
    return <LoadingSplash2 />;
  }

  if (!user?.token) {
    return (
      <>
        <Header isAuth={false} />
        <Routes>
          <Route path={"/*"} element={<Auth />} />
        </Routes>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Header isAuth={true} />
      <Routes>
        <Route path={"/"} element={<Home />} />
        <Route path={"/wallet"} element={<WalletList />} />
        <Route path={"/stake"} element={<Stake />} />
        <Route path={"/stake-for-voting"} element={<StakeForVoting />} lazy />
        <Route path={"/stake-for-option"} element={<StakeForOption />} lazy />
        <Route
          path={"/stake-by-option-detail"}
          element={<StakeForOptionDetail />}
          lazy
        />
        <Route
          path={"/stake-for-option-history"}
          element={<StakeHistory />}
          lazy
        />
        <Route
          path={"/claim-staking-request"}
          element={<ClaimStakingRequest />}
          lazy
        />
        <Route
          path={"/claim-stake-success"}
          element={<ClaimStakeSuccess />}
          lazy
        />
        <Route path={"/logout"} element={<Logout />} />
        <Route path={"/wallet-detail/:type"} element={<WalletDetail />} />
        <Route
          path={"/wallet-detail-history"}
          element={<WalletDetailHistory />}
        />
        <Route
          path={"/withdraw/:optionCoin/:optionWalletId"}
          element={<Withdraw />}
        />
        <Route path={"/withdraw"} element={<Withdraw />} />
        <Route path={"/claim-sot"} element={<ClaimSot />} />
        <Route path={"/withdraw-sgt"} element={<WithDrawSGT />} />
        <Route path={"/transfer-web3"} element={<TransferWeb3 />} />
        <Route path={"/mint-nft"} element={<MintNFT />} lazy />
        <Route path={"/asset"} element={<Asset />} />
        <Route path={"/earner-detail/:id"} element={<EarnerDetail />} />

        <Route path={"/change-password"} element={<ChangePassword />} lazy />
        <Route path={"/otp-verification"} element={<OtpVerification />} lazy />
        <Route path={"/payment-method"} element={<PaymentMethod />} lazy />
        <Route path={"/set-password"} element={<SetPassword />} lazy />
        <Route path={"/address-book"} element={<AddressBook />} lazy />
        <Route path={"/two-factor"} element={<TwoFactor />} lazy />
        <Route path={"/profile"} element={<Profile />} lazy />
        <Route path={"/stake-request"} element={<StakeSgt />} />
        <Route path={"/re-stake-request"} element={<ReStakeSgt />} />
        <Route path={"/my-purchase"} element={<MyPurchase />} />
        <Route path={"/stake-detail"} element={<StakeDetail />} />
        <Route path={"/stake-success"} element={<StakeSuccess />} />
        <Route path={"/card-information"} element={<CardInfo lazy />} />
        <Route path={"/commission"} element={<Commission />} lazy />
        <Route path={"/affiliate"} element={<Affiliate />} lazy />
        <Route
          path={"/affiliate/generate-links"}
          element={<AffiliateGenerate />}
          lazy
        />
        {user?.country_code === CountryCode.indo && (
          <Route
            path={"/commission-detail"}
            element={<CommissionDetail />}
            lazy
          />
        )}

        <Route path={"/confirm-phone"} element={<ConfirmPhone />} lazy />
        <Route
          path={"/transaction-history/:type"}
          element={<TransactionHistory />}
        />
        <Route path={"/line-callback"} element={<LineCallback />} />
        {/*  for old router  */}
        <Route
          path={"/otc/wallet-detail/:type/:id"}
          element={<WalletDetail />}
          lazy
        />
        <Route path={"/otc/withdraw"} element={<Withdraw />} lazy />
        <Route
          path={"/otc/transaction-history/:type"}
          element={<TransactionHistory />}
          lazy
        />
        {/*  all to main  */}
        <Route path={"/*"} element={<Navigate replace={true} to={"/"} />} />
      </Routes>
      {isOpenModalPolicy && (
        <ModalPolicy
          onClose={() => setIsOpenModalPolicy(false)}
          handleSubmit={() => onConfirmPolicy()}
          disabled={isAgreeing}
        />
      )}
      <Footer />
    </>
  );
}
